import { BadgeType, HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '../../models';
import { SYSTEM_ENUM_ROOT } from '../shared-data';

const dpRoot = `${SYSTEM_ENUM_ROOT}|Badge Type`;

export type CPBadgeTypeLocs = 'CPBadgeTypeEnumC' | 'CPBadgeTypeEnumE' | 'CPBadgeTypeEnumR';

export type SPBadgeTypeLocs = 'SPBadgeTypeEnumC' | 'SPBadgeTypeEnumE' | 'SPBadgeTypeEnumR';

export const cpBadgeTypeEnumLocs: LocDefs<CPBadgeTypeLocs> = {
	CPBadgeTypeEnumC: {
		defaultValue: 'Credential',
		displayPath: `${dpRoot}|${BadgeType.C}`,
		description: `System value for '${BadgeType.C}' badge type`,
		legacyName: 'Share.CertMetricsBadging/System.Enum.BadgeType.c',
		displayType: 'Content',
		feature: HubFeature.ShareCertMetricsBadging,
		portal: 'CP',
	},
	CPBadgeTypeEnumE: {
		defaultValue: 'Exam',
		displayPath: `${dpRoot}|${BadgeType.E}`,
		description: `System value for '${BadgeType.E}' badge type`,
		legacyName: 'Share.CertMetricsBadging/System.Enum.BadgeType.e',
		displayType: 'Content',
		feature: HubFeature.ShareCertMetricsBadging,
		portal: 'CP',
	},
	CPBadgeTypeEnumR: {
		defaultValue: 'Other Requirement',
		displayPath: `${dpRoot}|${BadgeType.R}`,
		description: `System value for '${BadgeType.R}' badge type`,
		legacyName: 'Share.CertMetricsBadging/System.Enum.BadgeType.r',
		displayType: 'Content',
		feature: HubFeature.ShareCertMetricsBadging,
		portal: 'CP',
	},
};

export const spBadgeTypeEnumLocs: LocDefs<SPBadgeTypeLocs> = {
	SPBadgeTypeEnumC: {
		defaultValue: 'Credential',
		displayPath: `${dpRoot}|${BadgeType.C}`,
		description: `System value for '${BadgeType.C}' badge type`,
		legacyName: 'Share.CertMetricsBadging/System.Enum.BadgeType.c',
		displayType: 'Content',
		feature: HubFeature.ShareCertMetricsBadging,
		portal: 'SP',
	},
	SPBadgeTypeEnumE: {
		defaultValue: 'Exam',
		displayPath: `${dpRoot}|${BadgeType.E}`,
		description: `System value for '${BadgeType.E}' badge type`,
		legacyName: 'Share.CertMetricsBadging/System.Enum.BadgeType.e',
		displayType: 'Content',
		feature: HubFeature.ShareCertMetricsBadging,
		portal: 'SP',
	},
	SPBadgeTypeEnumR: {
		defaultValue: 'Other Requirement',
		displayPath: `${dpRoot}|${BadgeType.R}`,
		description: `System value for '${BadgeType.R}' badge type`,
		legacyName: 'Share.CertMetricsBadging/System.Enum.BadgeType.r',
		displayType: 'Content',
		feature: HubFeature.ShareCertMetricsBadging,
		portal: 'SP',
	},
};

export const BADGE_TYPE_ENUM_LOCS = MapLocKeys<CPBadgeTypeLocs | SPBadgeTypeLocs>({
	...cpBadgeTypeEnumLocs,
	...spBadgeTypeEnumLocs,
});

export type CPBadgeTypeEnumLocType = LocMap<CPBadgeTypeLocs>;
export type SPBadgeTypeEnumLocType = LocMap<SPBadgeTypeLocs>;

export const cpBadgeTypeKeys: { [key in BadgeType]: keyof CPBadgeTypeEnumLocType } = {
	c: BADGE_TYPE_ENUM_LOCS.CPBadgeTypeEnumC,
	e: BADGE_TYPE_ENUM_LOCS.CPBadgeTypeEnumE,
	r: BADGE_TYPE_ENUM_LOCS.CPBadgeTypeEnumR,
};

export const spBadgeTypeKeys: { [key in BadgeType]: keyof SPBadgeTypeEnumLocType } = {
	c: BADGE_TYPE_ENUM_LOCS.SPBadgeTypeEnumC,
	e: BADGE_TYPE_ENUM_LOCS.SPBadgeTypeEnumE,
	r: BADGE_TYPE_ENUM_LOCS.SPBadgeTypeEnumR,
};
